import { motion } from "framer-motion";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { useSeo } from "../hooks/useSeo";

const ImpressumPage = () => {
  useSeo({ title: "Impressum | JS Blond Salon UG Leingarten", description: "Impressum der JS Blond Salon UG (haftungsbeschränkt), Daimlerstraße 26, 74211 Leingarten – Angaben gemäß § 5 TMG.", path: "/impressum" });
  return (
    <div className="min-h-screen bg-[#F9F7F2]">
      <Navigation />
      
      {/* Hero */}
      <section className="pt-32 pb-8 bg-white">
        <div className="container-padding">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <h1
              className="text-4xl md:text-5xl font-normal tracking-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Impressum
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 bg-[#F9F7F2]">
        <div className="container-padding">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-3xl space-y-8"
          >
            {/* Angaben gemäß § 5 TMG */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Angaben gemäß § 5 TMG
              </h2>
              <div className="space-y-2 text-[#2C2C2C]/80">
                <p className="font-medium">JS Blond Salon UG (haftungsbeschränkt)</p>
                <p>Daimlerstr. 26</p>
                <p>74211 Leingarten</p>
                <p className="mt-4">
                  <span className="text-[#9A8C73]">Ab Ende März 2025:</span><br />
                  Daimlerstr 26<br />
                  74211 Leingarten
                </p>
              </div>
            </div>

            {/* Vertreten durch */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Vertreten durch
              </h2>
              <p className="text-[#2C2C2C]/80">
                Fabian Sailer<br />
                Geschäftsführer
              </p>
            </div>

            {/* Kontakt */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Kontakt
              </h2>
              <div className="space-y-2 text-[#2C2C2C]/80">
                <p>E-Mail: info@js-blondsalon.de</p>
              </div>
            </div>

            {/* Registereintrag */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Registereintrag
              </h2>
              <div className="space-y-2 text-[#2C2C2C]/80">
                <p>Eintragung im Handelsregister</p>
                <p>Registergericht: Amtsgericht Stuttgart</p>
                <p>Registernummer: HRB 795929</p>
              </div>
            </div>

            {/* Umsatzsteuer-ID */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Steuernummern
              </h2>
              <div className="space-y-2 text-[#2C2C2C]/80">
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                  <strong>DE369402216</strong>
                </p>
                <p className="mt-2">
                  Steuernummer: <strong>65203/63775</strong>
                </p>
              </div>
            </div>

            {/* Berufsbezeichnung */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Berufsbezeichnung und berufsrechtliche Regelungen
              </h2>
              <div className="space-y-2 text-[#2C2C2C]/80">
                <p>Berufsbezeichnung: Friseurmeisterin</p>
                <p>Zuständige Kammer: Handwerkskammer Heilbronn-Franken</p>
                <p>Verliehen in: Deutschland</p>
              </div>
            </div>

            {/* Streitschlichtung */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Streitschlichtung
              </h2>
              <div className="space-y-4 text-[#2C2C2C]/80 text-sm">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#9A8C73] hover:underline ml-1">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </div>

            {/* Haftung für Inhalte */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Haftung für Inhalte
              </h2>
              <p className="text-[#2C2C2C]/80 text-sm leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von 
                Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine 
                diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten 
                Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen 
                werden wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            {/* Haftung für Links */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Haftung für Links
              </h2>
              <p className="text-[#2C2C2C]/80 text-sm leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung 
                auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
                Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten 
                Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. 
                Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>

            {/* Urheberrecht */}
            <div className="bg-white p-8 border border-[#E6E2D6]">
              <h2
                className="text-xl font-medium mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Urheberrecht
              </h2>
              <p className="text-[#2C2C2C]/80 text-sm leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite 
                sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte 
                auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter 
                beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie 
                trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen 
                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige 
                Inhalte umgehend entfernen.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ImpressumPage;
